import React, { createContext, useContext, useState, useMemo } from 'react';

/* Setters are stable (useState setters never change) — consuming this context
   never causes a re-render when title/meta values change. */
const PageSettersContext = createContext({ setTitle: () => {}, setMeta: () => {} });

/* Values context — only layout components that display the values need this. */
const PageValuesContext = createContext({ title: '', meta: null });

export const PageProvider = ({ children }) => {
  const [title, setTitle] = useState('');
  const [meta,  setMeta]  = useState(null);

  const setters = useMemo(() => ({ setTitle, setMeta }), [setTitle, setMeta]);

  return (
    <PageSettersContext.Provider value={setters}>
      <PageValuesContext.Provider value={{ title, meta }}>
        {children}
      </PageValuesContext.Provider>
    </PageSettersContext.Provider>
  );
};

/** Use in pages that WRITE title/meta — stable, never triggers re-renders. */
export const usePageSetters = () => useContext(PageSettersContext);

/** Use in layout components that READ title/meta — re-renders when values change. */
export const usePageValues  = () => useContext(PageValuesContext);

/** Backwards-compat alias (still used in a few places). */
export const usePageTitle = usePageSetters;
